import React from 'react';
import { Skeleton } from 'antd';
import { Card, Text } from '@clockout-dev/design-elements';
import TransactionSummaryTable from './TransactionSummaryTable';
import styles from './styles/user-summary-section.module.scss';

function TransactionSummarySection({ rows = [], loading = false, pageInfo = null, onTableChange }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Transaction Summary</Text>
            <Card className={styles.card}>
                {loading ? (
                    <Skeleton active paragraph={{ rows: 8 }} />
                ) : (
                    <TransactionSummaryTable
                        rows={rows}
                        loading={false}
                        pageInfo={pageInfo}
                        onTableChange={onTableChange}
                    />
                )}
            </Card>
        </section>
    );
}

export default TransactionSummarySection;
